import { InquiryForm } from '@/features/inquiry/InquiryForm'

export default function Inquire() {
  return (
    <div className="min-h-screen bg-cream-100">

      {/* Hero — image with overlay, replaces solid dark banner */}
      <div className="relative h-64 lg:h-80 overflow-hidden">
        <img
          src="/images/optimized/IMG_5174.webp"
          alt="Scenic Solitude"
          fetchPriority="high"
          className="h-full w-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-forest-950/55" />
        <div className="absolute inset-0 flex flex-col items-center justify-center text-center">
          <p className="text-[10px] tracking-[0.35em] uppercase text-white/55 font-semibold mb-3">Reservations</p>
          <h1 className="text-4xl font-semibold text-white tracking-tight">Book a Stay</h1>
          <p className="mt-2 text-sm text-white/60">We'll respond within 24 hours to confirm availability</p>
        </div>
      </div>

      {/* Form — centered, same as before */}
      <div className="mx-auto max-w-2xl px-8 lg:px-16 py-16">
        <p className="text-sm text-ink-soft font-light leading-relaxed mb-10">
          Fill in the form below and we'll get back to you within 24 hours to confirm availability
          and discuss your stay.
        </p>
        <InquiryForm />
      </div>

    </div>
  )
}
